import React, {useEffect} from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import configureStore from './configureStore';
import PagesRouter from './pagesRouter/pagesRouter';
import {ThemeProvider} from 'styled-components';
import theme from './theme';
import './helpers';
import './log';
import './error';
import './init';
import 'moment/locale/ru';
import './assets/css/normalize.css';
import './assets/css/main.css';
import './assets/css/calendar.css';
import './assets/css/treemap.css';
import './assets/css/tactics.css';
import './assets/css/case.css';
import './assets/css/bigcase.css';
import './assets/css/insurance.css';
import './assets/css/rc-slider.css';
import './assets/css/popup.css';
import { QUERY_CACHE_TIMES } from './constants/queryCacheTimes';

// Настройка TanStack Query
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: QUERY_CACHE_TIMES.FAST_UPDATE,
        },
    },
});

const store = configureStore({}, queryClient);


const App = () => {
    useEffect(() => {
        // Как только React полностью смонтировался — скрываем бар
        if (window.__hideLoadingBar) {
            window.__hideLoadingBar();
        }
    }, []); // пустой массив — сработает один раз при монтировании

    return <BrowserRouter
        future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}
    >
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                    <PagesRouter/>
                </Provider>
            </QueryClientProvider>
        </ThemeProvider>
    </BrowserRouter>
};

// Функция для скрытия прелоадера
const hidePreloader = () => {
    const preloader = document.getElementById('preloader');
    if (preloader) {
        preloader.classList.add('hidden');
        // Можно добавить небольшую задержку для плавности
        setTimeout(() => {
            preloader.remove();
        }, 300);
    }
};

const container = document.getElementById('app');

if (container.hasChildNodes()) {
    // Если в #app уже есть статичный HTML → гидратируем
    hydrateRoot(container, <App />);
    hidePreloader()
} else {
    // Если контейнер пустой → монтируем заново
    createRoot(container).render(<App />);
    hidePreloader()
}